// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DemoRentalAttributesCriteria from './demo-rental-history-attributes-criteria';
import DemoRentalHistoryDateRangeCriteria from './demo-rental-history-date-range-criteria';
import DemoRentalHistoryDealerCriteria from './demo-rental-history-dealer-criteria';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const DemoRentalHistoryCriteria = props =>
    <div className='demo-rental-history-criteria'>
        <div className='criteria-container'>
            <DemoRentalHistoryDealerCriteria
                allowedAccounts={props.allowedAccounts}
                dealers={props.criteria.dealers}
                onSelectAllDealers={props.onSelectAllDealers}
                onSelectedAccountsChange={props.onSelectedAccountsChange}
            />
            <DemoRentalAttributesCriteria
                branch={props.branch}
                branches={props.branches}
                factory={props.factoryCode}
                factoryCodes={props.factoryCodes}
                onBranchChange={props.onBranchChange}
                onFactoryChange={props.onFactoryChange}
                onPinChange={props.onPinChange}
                onProductRegistered={props.onProductRegistered}
                onStatusChange={props.onStatusChange}
                pin={props.pin}
                productRegistered={props.productRegistered}
                status={props.status}
                statuses={props.statuses}
            />
            <DemoRentalHistoryDateRangeCriteria
                beginDate={props.criteria.beginDate}
                endDate={props.criteria.endDate}
                onBeginDateChange={props.onBeginDateChange}
                onEndDateChange={props.onEndDateChange}
            />

        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onRunReport}
            showExport={true}
            showReport={true}
        />
    </div>;

DemoRentalHistoryCriteria.displayName = 'DemoRentalHistoryCriteria';
DemoRentalHistoryCriteria.propTypes = {
    allowedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    branch: PropTypes.string.isRequired,
    branches: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    factoryCode: PropTypes.string.isRequired,
    factoryCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onBeginDateChange: PropTypes.func.isRequired,
    onBranchChange: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onEndDateChange: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onFactoryChange: PropTypes.func.isRequired,
    onPinChange: PropTypes.func.isRequired,
    onProductRegistered: PropTypes.func.isRequired,
    onRunReport: PropTypes.func.isRequired,
    onSelectAllDealers: PropTypes.func.isRequired,
    onSelectedAccountsChange: PropTypes.func.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    pin: PropTypes.string.isRequired,
    productRegistered: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default DemoRentalHistoryCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-report-criteria.js